import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import GlobalStyles from '../../assets/styles/global';
import defaultTheme from '../../assets/styles/themes/default';

import { AuthProvider, useAuth } from '../../context/AuthContext';
import { CustomerSelectorProvider } from '../../context/CustomerSelectorContext';
import { Container } from './styles';
import SignUp from '../SignUp';
import Login from '../Login';
import AccountActivation from '../AccountActivation';
import PasswordRecovery from '../PasswordRecovery';
import ResetPassword from '../ResetPassword';
import Layout from '../Layout';
import Dashboard from '../Dashboard';
import Vehicles from '../Vehicles';
import Employees from '../Employees';
import Deliveries from '../Deliveries';
import NewDelivery from '../Deliveries/NewDelivery';
import Clients from '../Clients';
import { UserProfileView } from '../Profile';
import Rotas from '../Rotas';
import Roteiros from '../Roteiros';
import FaturasList from '../Faturas';
import NewInvoice from '../Faturas/NewInvoice';
import InvoiceDetail from '../Faturas/InvoiceDetail';
import Relatorios from '../Relatorios';
import Configuracoes from '../Configuracoes';


function AuthPage() {
    const [isLogin, setIsLogin] = useState(true);
    const { signed, isLoading } = useAuth();

    if (isLoading) {
        return <div>Carregando...</div>;
    }

    if (signed) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <Container>
            {isLogin ? (
                <Login onSwitchToRegister={() => setIsLogin(false)} />
            ) : (
                <SignUp onSwitchToLogin={() => setIsLogin(true)} />
            )}
        </Container>
    );
}

function ProtectedRoute({ children }) {
    const { signed, isLoading } = useAuth();

    if (isLoading) {
        return <div>Carregando...</div>;
    }

    if (!signed) {
        return <Navigate to="/" />;
    }

    return children;
}

/** Layout da área protegida: sidebar + header + Outlet (conteúdo definido pelas rotas filhas). */
function ProtectedShell() {
    return (
        <ProtectedRoute>
            <CustomerSelectorProvider>
                <Layout />
            </CustomerSelectorProvider>
        </ProtectedRoute>
    );
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<AuthPage />} />
            <Route path="/ativar-conta" element={<AccountActivation />} />
            <Route path="/recuperar-senha" element={
                <Container>
                    <PasswordRecovery />
                </Container>
            } />
            <Route path="/redefinir-senha" element={
                <Container>
                    <ResetPassword />
                </Container>
            } />
            <Route element={<ProtectedShell />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="entregas" element={<Deliveries />} />
                <Route path="entregas/nova" element={<NewDelivery />} />
                <Route path="entregas/:id" element={<NewDelivery />} />
                <Route path="rotas/*" element={<Rotas />} />
                <Route path="roteiros/*" element={<Roteiros />} />
                <Route path="colaboradores" element={<Employees />} />
                <Route path="veiculos" element={<Vehicles />} />
                <Route path="relatorios" element={<Relatorios />} />
                <Route path="faturas" element={<FaturasList />} />
                <Route path="faturas/nova" element={<NewInvoice />} />
                <Route path="faturas/:id" element={<InvoiceDetail />} />
                <Route path="clientes" element={<Clients />} />
                <Route path="perfil" element={<UserProfileView />} />
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider theme={defaultTheme}>
            <GlobalStyles />
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;

